import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { onBoardingSuccessIcon } from "@/lib/Images";

export const CustomSuccessModal = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  helperText,
  cancelText = "Cancel",
  confirmText = "Save",
  confirmButtonClassName = "bg-brand-21 hover:bg-brand-22",
}) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent
        className="
          w-[calc(100vw-32px)]
          max-w-[720px]
          rounded-lg
          border
          border-brand-11
          bg-brand-19
          px-6
          py-10
          text-center
          text-neutral-100
          shadow-2xl
          sm:px-10
          sm:py-12
        "
      >
        <DialogHeader className="text-center">
          <div className="mx-auto mb-5 flex items-center justify-center">
            <img
              src={onBoardingSuccessIcon}
              className={ "h-52 w-68"}
              alt="Publish"
            />
          </div>

          <DialogTitle className="text-center text-2xl font-bold text-[#67D8FF]">
            {title}
          </DialogTitle>

          {description && (
            <DialogDescription className="mx-auto mt-5 max-w-xl text-center text-sm font-semibold leading-relaxed text-neutral-100">
              {description}
            </DialogDescription>
          )}

          {helperText && (
            <p className="mx-auto mt-5 max-w-xl text-center text-sm font-semibold text-[#67D8FF]">
              {helperText}
            </p>
          )}
        </DialogHeader>

        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            className="h-10 min-w-[110px] border-[#607A9B] bg-[#223957] px-8 font-bold text-neutral-100 hover:bg-[#2B466B] hover:text-neutral-100"
          >
            {cancelText}
          </Button>

          <Button
            type="button"
            onClick={onConfirm}
            className={`h-10 min-w-[140px] px-8 font-bold text-neutral-100 ${confirmButtonClassName}`}
          >
            {confirmText}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
